export class MapaIn {
    constructor() {}
    commonStep = 'stepper.form.commun.mapa.step';
    step = 'stepper.form.mapa_in.step';

  }
